module.exports = __webpack_public_path__ + "img/kleisma2m-m@2.825794d4.jpg";